export const openManual = (path: string): void => {window.open(path, "manuals")}
